import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  root: {
    '& .rs-form-group': {
      marginBottom: 24
    }
  }
});
